module.exports = __webpack_public_path__ + "static/r2d2-ae7c941a0d37cfd0f09da36ae8ff4542.jpg";